var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.42 7.95012C18.86 10.3901 18.86 14.3501 16.42 16.7901C13.98 19.2301 10.02 19.2301 7.58 16.7901C5.14 14.3501 5.14 10.3901 7.58 7.95012C10.02 5.51012 13.98 5.51012 16.42 7.95012Z",
    fill: "#002C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.25003 22.3899C8.16003 22.3899 8.06004 22.3699 7.97004 22.3399C5.72004 21.4399 3.90003 19.8499 2.68003 17.7499C1.50003 15.6999 1.03003 13.3799 1.34003 11.0199C1.39003 10.6099 1.78003 10.3199 2.18003 10.3699C2.59003 10.4199 2.88002 10.7999 2.83002 11.2099C2.57002 13.2299 2.97005 15.2299 3.98005 16.9899C5.02005 18.7899 6.59002 20.1599 8.52002 20.9299C8.90002 21.0899 9.09004 21.5198 8.94004 21.9098C8.83004 22.2098 8.54003 22.3899 8.25003 22.3899Z",
    fill: "#002C58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.8501 5.22986C5.6301 5.22986 5.4101 5.12988 5.2601 4.93988C5.0001 4.60988 5.06011 4.13989 5.39011 3.88989C7.30011 2.39989 9.58009 1.60986 12.0001 1.60986C14.3601 1.60986 16.6101 2.36988 18.5001 3.80988C18.8301 4.05988 18.8901 4.52986 18.6401 4.85986C18.3901 5.18986 17.9201 5.24988 17.5901 4.99988C15.9701 3.75988 14.0401 3.10986 12.0001 3.10986C9.92009 3.10986 7.95009 3.78989 6.31009 5.06989C6.17009 5.17989 6.0101 5.22986 5.8501 5.22986Z",
    fill: "#002C58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7502 22.3901C15.4502 22.3901 15.1702 22.2101 15.0502 21.9201C14.9002 21.5401 15.0802 21.1001 15.4702 20.9401C17.4002 20.1601 18.9702 18.8001 20.0102 17.0001C21.0302 15.2401 21.4302 13.2401 21.1602 11.2201C21.1102 10.8101 21.4002 10.4301 21.8102 10.3801C22.2102 10.3301 22.6002 10.6201 22.6502 11.0301C22.9502 13.3801 22.4902 15.7101 21.3102 17.7601C20.1002 19.8601 18.2702 21.4401 16.0202 22.3501C15.9402 22.3701 15.8502 22.3901 15.7502 22.3901Z",
    fill: "#002C58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.00d8ca1af1d63442b43c0944f9235f34.svg";
export { ForwardRef as ReactComponent };